import { useEffect, useState } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';

import { getDayPeriod, getResponsiveImages } from '../components/business/app/landing-page/sign-up-banner/time-based-images';

export function useDayPeriodResponsiveImage(options?: { date?: Date; refreshMinutes?: number }): string {
  const { date, refreshMinutes = 10 } = options || {};
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'lg'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  function categoryFromMedia(): 'mobile' | 'tablet' | 'desktop' {
    if (isDesktop) return 'desktop';
    if (isTablet) return 'tablet';
    return 'mobile';
  }

  const [src, setSrc] = useState<string>(() => {
    const period = getDayPeriod(date);
    const responsive = getResponsiveImages(period);
    return responsive[categoryFromMedia()];
  });

  useEffect(() => {
    function update() {
      const period = getDayPeriod(date);
      const responsive = getResponsiveImages(period);
      setSrc(responsive[categoryFromMedia()]);
    }
    update();
    const interval = window.setInterval(update, refreshMinutes * 60 * 1000);
    window.addEventListener('resize', update);

    return () => {
      window.clearInterval(interval);
      window.removeEventListener('resize', update);
    };
  }, [date, refreshMinutes, isMobile, isTablet, isDesktop]);

  return src;
}
